import React, { useEffect, useRef } from "react";
import EmojiPicker from "emoji-picker-react";

const EmojiPckerCom  = ({ showEmoji, setShowEmoji ,isBlocked,setFormValue}) => {
  const emojiPickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmoji(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [emojiPickerRef]);
  return (
    <div>
      {" "}
      {showEmoji && (
        <div ref={emojiPickerRef} className="position-relative">
          <EmojiPicker
            id="emojiPicker"
            onEmojiClick={
              isBlocked
                ? null
                : (e) => {
                    setFormValue((prevValues) => ({
                      ...prevValues,
                      newMessage: prevValues.newMessage + e.emoji,
                    }));
                  }
            }
            emojiStyle="google"
            searchPlaceHolder="Buscar emoji..."
            lazyLoadEmojis={true}
            previewConfig={{ showPreview: false }}
            theme="auto"
            className="position-absolute"
            style={{
              zIndex: "1000",
              bottom: "50px",
              left: "0",
              maxHeight: "400px",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default EmojiPckerCom ;
